module.exports = __webpack_public_path__ + "static/media/ricardo-perez-icon-noneOption.a9aa6df6.svg";